import React, { useMemo, useState } from 'react';
import { ScreenshotsView } from './Screenshots.view';
import {
  DEMO_MEMBERS_OPTIONS,
  DEMO_SESSIONS_BY_DAY,
  DEMO_SESSION_SCREENSHOTS,
} from './Screenshots.demoData';

const DEMO_TIMEZONE = 'America/New_York';
const DEMO_TEAM_NAME = 'Engineering';

export const ScreenshotsDemoComponent = () => {
  const [selectedMember, setSelectedMember] = useState(DEMO_MEMBERS_OPTIONS[0]);
  const [selectedTimezone, setSelectedTimezone] = useState(DEMO_TIMEZONE);
  const [range, setRange] = useState({
    start: DEMO_SESSIONS_BY_DAY[0]?.dayKey,
    end: DEMO_SESSIONS_BY_DAY[0]?.dayKey,
  });
  const [expandedSessions, setExpandedSessions] = useState(
    () => new Set([DEMO_SESSIONS_BY_DAY[0]?.sessions?.[0]?.id])
  );
  const [screenshotModalOpen, setScreenshotModalOpen] = useState(false);
  const [selectedScreenshotIndex, setSelectedScreenshotIndex] = useState(0);
  const [allScreenshotsList, setAllScreenshotsList] = useState([]);
  const [modalOpenToken, setModalOpenToken] = useState(0);

  const employeeName = selectedMember?.label?.replace(/\s*\([^)]*\)\s*$/, '');

  const flattenedSessions = useMemo(() => {
    const rows = [];
    DEMO_SESSIONS_BY_DAY.forEach((day) => {
      day.sessions.forEach((session) => {
        rows.push({ dayLabel: day.dayLabel, dayKey: day.dayKey, session });
      });
    });
    return rows;
  }, []);

  const onSessionOpenChange = (sessionId, open) => {
    setExpandedSessions((prev) => {
      const next = new Set(prev);
      if (open) {
        next.add(sessionId);
      } else {
        next.delete(sessionId);
      }
      return next;
    });
  };

  const openScreenshotModal = (clickedIndex, screenshots) => {
    const allScreenshots = [];
    DEMO_SESSIONS_BY_DAY.forEach((day) => {
      day.sessions.forEach((session) => {
        const sessionScreens = DEMO_SESSION_SCREENSHOTS[session.id] || [];
        sessionScreens.forEach((screenshot) => {
          allScreenshots.push({
            ...screenshot,
            sessionId: session.id,
            dayLabel: day.dayLabel,
          });
        });
      });
    });

    setAllScreenshotsList(allScreenshots);

    const clickedScreenshot = screenshots[clickedIndex];
    const foundIndex = allScreenshots.findIndex(
      (s) =>
        s.url === clickedScreenshot.url &&
        s.timestamp === clickedScreenshot.timestamp &&
        s.activityId === clickedScreenshot.activityId
    );
    setSelectedScreenshotIndex(foundIndex >= 0 ? foundIndex : 0);
    setScreenshotModalOpen(true);
    setModalOpenToken((token) => token + 1);
  };

  const closeScreenshotModal = () => {
    setScreenshotModalOpen(false);
    setSelectedScreenshotIndex(0);
    setAllScreenshotsList([]);
  };

  return (
    <ScreenshotsView
      membersOptions={DEMO_MEMBERS_OPTIONS}
      selectedMember={selectedMember}
      onMemberFilterChange={setSelectedMember}
      membersLoading={false}
      membersError={false}
      membersErrorObj={null}
      refetchMembers={() => {}}
      timezoneOptions={[{ value: DEMO_TIMEZONE, label: DEMO_TIMEZONE }]}
      selectedTimezone={selectedTimezone}
      onTimezoneChange={setSelectedTimezone}
      timezonesLoading={false}
      date={range.start}
      onDateChange={(dateStr) => setRange({ start: dateStr, end: dateStr })}
      onRefresh={() => {}}
      loading={false}
      flattenedSessions={flattenedSessions}
      sessionScreenshots={DEMO_SESSION_SCREENSHOTS}
      loadingScreenshots={{}}
      expandedSessions={expandedSessions}
      onSessionOpenChange={onSessionOpenChange}
      onOpenScreenshotModal={openScreenshotModal}
      screenshotModalOpen={screenshotModalOpen}
      closeScreenshotModal={closeScreenshotModal}
      allScreenshotsList={allScreenshotsList}
      selectedScreenshotIndex={selectedScreenshotIndex}
      setSelectedScreenshotIndex={setSelectedScreenshotIndex}
      employeeName={employeeName}
      teamName={DEMO_TEAM_NAME}
      modalOpenToken={modalOpenToken}
    />
  );
};
